<template>
  <v-btn v-bind="{ ...$attrs, ...commonAttrs }">
    <BrandIcon class="text-h5 mr-2" name="facebook" />
    <slot />
  </v-btn>
</template>

<script>
import BrandIcon from './BrandIcon.vue'

export default {
  components: { BrandIcon },
  inheritAttrs: false,
  computed: {
    commonAttrs() {
      return {
        color: '#1877F2',
        variant: 'elevated',
        class: [
          'text-none text-white',
          'rounded-lg',
        ],
      }
    },
  },
}
</script>
